// Page Loader Effect

function enableLoader() {
    document.body.classList.add('loading');
}
function disableLoader() {
    document.body.classList.add('loaded');
    document.body.classList.remove('loading');
}
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(enableLoader, 50);
});
window.addEventListener('load', () => {
    setTimeout(disableLoader, 500);
});



// WEBPACK FOOTER //
// ./assets/js/src/modules/pageloader.js